// extracted by mini-css-extract-plugin
export var legendIndicator = "_ie-1";
export var legendRight = "_ie-0";